<h2
  mat-dialog-title
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  {{ "trips.activity.trip-component" | translate }}
</h2>

<!-- Global form-level validation error -->
<validation-error-bar
  [formGroup]="form"
  [validationMessages]="{
    bothOrNoneRequired: 'trips.activity.required-both-times'
  }"
  [relevantControls]="['startTime', 'endTime']"
></validation-error-bar>
<ng-container *ngIf="form">
  <mat-dialog-content [formGroup]="form" class="dialog-content">
    <div class="grid-container">
      <!-- Name -->
      <mat-form-field appearance="outline" class="span-2-cols">
        <mat-label>{{
          "trips.activity.trip-component-name" | translate
        }}</mat-label>
        <input matInput formControlName="name" required />
        <mat-error
          *ngIf="form.get('name')?.invalid && form.get('name')?.touched"
        >
          {{ "trips.activity.trip-component-name-required" | translate }}
        </mat-error>
      </mat-form-field>

      <!-- Start Time -->
      <input-time formControlName="startTime" label="start-time"></input-time>

      <!-- End Time -->
      <input-time formControlName="endTime" label="end-time"></input-time>

      <!-- Total Price -->
      <input-monetary-amount 
        appRoleBasedVisibility
        [allowedRoles]="['SUPER_ADMIN']"
        formControlName="totalPrice"
        label="total-price"
      ></input-monetary-amount>

      <!-- Description -->
      <mat-form-field appearance="outline" class="span-2-cols">
        <mat-label>{{ "description" | translate }}</mat-label>
        <textarea
          matInput
          formControlName="description"
          rows="3"
          maxlength="500"
        ></textarea>
        <mat-hint
          >{{ form.get("description")?.value?.length || 0 }}/500</mat-hint
        >
      </mat-form-field>

      <!-- Disclaimer -->
      <mat-form-field appearance="outline" class="span-2-cols">
        <mat-label>{{ "disclaimer" | translate }}</mat-label>
        <textarea
          matInput
          formControlName="disclaimer"
          rows="3"
          maxlength="500"
        ></textarea>
        <mat-hint
          >{{ form.get("disclaimer")?.value?.length || 0 }}/500</mat-hint
        >
      </mat-form-field>

      <!-- Notes -->
      <mat-form-field appearance="outline" class="span-2-cols">
        <mat-label>{{ "notes" | translate }}</mat-label>
        <textarea matInput formControlName="notes" rows="3"></textarea>
      </mat-form-field>
    </div>

    <mat-divider class="legal-section-divider"></mat-divider>
    <!-- <div class="grid-container">
      <mat-form-field appearance="outline">
        <mat-label>{{ "legal-name" | translate }}</mat-label>
        <input matInput type="text" formControlName="legalName" />
        <mat-error
          *ngIf="
            form.get('legalName')?.invalid && form.get('legalName')?.touched
          "
        >
          {{ "required-legal-name" | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ "fiscal-address" | translate }}</mat-label>
        <input matInput type="text" formControlName="fiscalAddress" />

        <mat-error
          *ngIf="
            form.get('fiscalAddress')?.invalid &&
            form.get('fiscalAddress')?.touched
          "
        >
          {{ "required-fiscal-address" | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ "iva-code" | translate }}</mat-label>
        <input
          matInput
          type="text"
          formControlName="ivaCode"
          style="text-transform: uppercase"
          (input)="toUppercase($event)"
        />
        <mat-error
          *ngIf="form.get('ivaCode')?.invalid && form.get('ivaCode')?.touched"
        >
          {{ "required-iva-code" | translate }}
        </mat-error>
      </mat-form-field>

      <input-date
        [label]="'advance-purchase-date'"
        [required]="shouldFiscalFieldsBeRequired()"
        formControlName="advancePurchaseDate"
      >
      </input-date>
    </div> -->

    <!-- Fiscal data -->
    <input-fiscal-data
      appRoleBasedVisibility
      [allowedRoles]="['SUPER_ADMIN']"
      [formGroup]="form"
      [required]="false"
    ></input-fiscal-data>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-content">
    <button mat-button (click)="cancel()">{{ "cancel" | translate }}</button>
    <button
      mat-raised-button
      color="primary"
      (click)="confirm()"
      [disabled]="!form.valid"
    >
      {{ "confirmation" | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>
